import React from 'react';
import { Button, Box, Typography, Card, CardContent, Switch, Grid, Avatar, Divider } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PeopleIcon from '@mui/icons-material/People';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import WidgetFormDialog from 'src/widgets/WidgetFormDialog';
import WidgetFormTextField from 'src/widgets/WidgetFormTextField';
import WidgetAlert from 'src/widgets/WidgetAlert';
import useAddRol from 'src/hooks/useAddRol';

const moduleOptions = [
    { key: 'activateRoles', label: 'Roles', Icon: AdminPanelSettingsIcon },
    { key: 'activateUsers', label: 'Usuarios', Icon: PeopleIcon },
    { key: 'activateExist', label: 'Existencias', Icon: Inventory2Icon },
    { key: 'activatePrecio', label: 'Precio', Icon: AttachMoneyIcon },
    { key: 'activateTokens', label: 'Tokens', Icon: VpnKeyIcon },
    { key: 'activatePedidos', label: 'Pedidos', Icon: ShoppingCartIcon },
    { key: 'activateExport', label: 'Exportación', Icon: FileUploadIcon },
];

const AddRol = ({ getRoles, handlerOpenAlertAdd }) => {
    const {
        open,
        handleOpen,
        handleClose,
        name,
        setName,
        description,
        setDescription,
        modules,
        updateModule,
        onSave,
        alert,
        closeAlert,
    } = useAddRol(getRoles, handlerOpenAlertAdd);

    return (
        <>
            <Button
                variant="contained"
                onClick={handleOpen}
                startIcon={<AdminPanelSettingsIcon />}
                sx={{
                    background: 'linear-gradient(120deg,#556cd6, #4dd0e1)',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 700,
                    boxShadow: '0 6px 18px rgba(85,108,214,0.18)',
                    borderRadius: 12,
                    px: 2.5,
                    py: 1,
                    transition: 'transform .16s ease, box-shadow .16s ease',
                    '&:hover': {
                        boxShadow: '0 10px 28px rgba(85,108,214,0.22)',
                        transform: 'translateY(-2px)'
                    },
                    '& .MuiButton-startIcon': { mr: 0.6 } // reduce espacio entre ícono y texto del botón
                }}
            >
                Agregar Rol
            </Button>

            <WidgetFormDialog open={open} title="Agregar Rol" onClose={handleClose} onAccept={onSave}>
                <Box sx={{ p: { xs: 2.5, md: 3.5 }, minWidth: { md: 780 }, background: 'linear-gradient(180deg, rgba(250,250,250,0.95), rgba(245,247,250,0.95))', borderRadius: 4 }}>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <WidgetFormTextField
                            label="Nombre del rol *"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />

                        <WidgetFormTextField
                            label="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 2, color: 'text.primary' }}>
                        Módulos
                    </Typography>

                    <Grid container spacing={2}>
                        {moduleOptions.map((m) => (
                            <Grid item xs={12} sm={6} md={4} key={m.key}>
                                <Card
                                    elevation={0}
                                    sx={{
                                        borderRadius: 12,
                                        p: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        backgroundColor: 'transparent',
                                        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                                        '&:hover': {
                                            transform: 'translateY(-6px)',
                                            boxShadow: '0 14px 30px rgba(12,30,60,0.08)'
                                        },
                                    }}
                                >
                                    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2, px: 2.25, width: '100%', background: '#fff', borderRadius: 3, minHeight: 90 }}>
                                        <Avatar sx={{ bgcolor: 'transparent', width: 44, height: 44, boxShadow: '0 4px 12px rgba(16,24,40,0.04)' }}>
                                            <m.Icon sx={{ fontSize: 20, color: 'primary.main' }} />
                                        </Avatar>

                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <Typography sx={{ fontWeight: 700, color: 'text.primary', fontSize: '1rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', mr: 0.5 }}>
                                                {m.label}
                                            </Typography>

                                            <Switch
                                                size="small"
                                                checked={!!modules[m.key]}
                                                onChange={(e) => updateModule(m.key, e.target.checked)}
                                                inputProps={{ 'aria-label': `${m.label} toggle` }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </WidgetFormDialog>

            <WidgetAlert {...alert} onClose={closeAlert} />
        </>
    );
};

export default AddRol;
